import { cn } from "@/lib/utils";
import type { Breakpoint, BreakpointProps } from "../types";

export const BREAKPOINTS: Breakpoint[] = ["sm", "md", "lg"];

type MergeBreakpointClassesOpts = {
  base?: BreakpointProps;
  props: {
    className?: string;
    [key: string]: any;
  };
};

export function mergeBreakpointClasses({
  base = {},
  props,
}: MergeBreakpointClassesOpts): string {
  const { className = "" } = props;

  const responsiveClasses = BREAKPOINTS.map(bp =>
    cn(base?.[bp], props?.[bp] ?? ""),
  );

  return cn(className, ...responsiveClasses);
}
